var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { mixpanelTracking } from '@/services/mixpanel';
let AppsTabsComponent = class AppsTabsComponent extends Vue {
    constructor() {
        super(...arguments);
        this.showRecordConfig = false;
        this.showSmartApproach = false;
    }
    mounted() {
        if (this.$route.name === 'recordApp') {
            this.showRecordConfig = true;
        }
        if (this.$route.name === 'smartApproachApp') {
            this.showSmartApproach = true;
        }
    }
    handleMixpanelTabTraking(text) {
        mixpanelTracking(`shop: Abriu a aba ${text}`);
    }
    get userIsNotProspector() {
        // @ts-ignore
        const user = this.$auth.user();
        return user && user.role !== 'prospector';
    }
    get hasWhatsapp_sender() {
        // @ts-ignore
        const user = this.$auth.user();
        return (user &&
            Array.isArray(user.features) &&
            user.features.includes('whatsapp_sender'));
    }
};
AppsTabsComponent = __decorate([
    Component({
        name: 'AppsTabsComponent',
    })
], AppsTabsComponent);
export default AppsTabsComponent;
